module.exports = __webpack_public_path__ + "static/media/app-download-buttons.9ffbfead.jpg";